exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  margin-top: 5px;\n  -ms-flex: 0 1 20px;\n      flex: 0 1 20px;\n  min-height: 10px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row;\n      flex-flow: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  color: white;\n  -ms-flex-align: center;\n      align-items: center; }\n  :host > span {\n    -ms-flex: 1 1 1px;\n        flex: 1 1 1px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/game-view/tip-selection/tip-selection.component.scss
// module id = ../../../../../src/app/game-view/tip-selection/tip-selection.component.scss
// module chunks = 1